// react components
import React from 'react'
import axios, {
    CancelTokenSource,
} from 'axios'

// data
import {
    reduxAuthStateSite,
    reduxModalStateSite,
} from 'data'

// services
import {
    axiosErrorHandlerSite,
    getAxiosHeadersSite,
} from 'services'

export function getDetailObjectSite({
    apiUrl,
    axiosCancelToken,
    component,
    customFunction,
    dispatch,
    noHeaders,
    reduxAuth,
    reduxModalSite,
    setAxiosCancelToken,
    setDetailObject,
    setErrorStatus,
    setIsLoading,
    skipErorrHandling,
}: {
    apiUrl: string
    axiosCancelToken?: CancelTokenSource
    component: string
    customFunction?: (e: any) => void
    dispatch: React.Dispatch<any>
    noHeaders?: boolean
    reduxAuth: reduxAuthStateSite
    reduxModalSite: reduxModalStateSite,
    setAxiosCancelToken?: React.Dispatch<CancelTokenSource>
    setDetailObject: React.Dispatch<any>
    setErrorStatus?: React.Dispatch<any>
    setIsLoading?: React.Dispatch<boolean>
    skipErorrHandling?: boolean
}) {

    if (axiosCancelToken) axiosCancelToken.cancel('axios canceled')

    if (!apiUrl) return

    if (setIsLoading) setIsLoading(true)

    const refreshAxiosHeaders = getAxiosHeadersSite(reduxAuth, reduxModalSite, dispatch)

    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    if (setAxiosCancelToken) setAxiosCancelToken(source)

    if (process.env.NODE_ENV === 'development') console.log(apiUrl)

    axios({
        headers: noHeaders ? undefined : refreshAxiosHeaders,
        method: 'get',
        url: apiUrl,
        cancelToken: source.token,
    })
        .then((response) => {
            if (process.env.NODE_ENV === 'development') console.log(response)
            setDetailObject(response.data)
            if (setIsLoading) setIsLoading(false)
            if (customFunction) customFunction(response.data)
        })
        .catch((error) => {
            if (setIsLoading) setIsLoading(false)
            if (skipErorrHandling) return
            if (setErrorStatus && error.response?.status === 403) {
                setErrorStatus(error.response.status)
            } else if (setErrorStatus && error.response?.status === 404 && error.response?.data?.detail) {
                setErrorStatus(error.response.status)
            } else {
                axiosErrorHandlerSite({
                    apiUrl,
                    component,
                    dispatch,
                    error,
                    reduxAuth,
                    reduxModalSite,
                    reference: 'getDetailObjectSite',
                })
            }
        })
}
